
import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication-service';
import { jwtDecode } from 'jwt-decode';

@Injectable()
export class LoadPermissionService {

    // As permissions não são usadas no momento, por enqunto usamos roles para controlar as permissões
    private permissions: string[] = [];

    public loadPermissions(): Promise<string[]> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                const token = AuthenticationService.getStoredToken();
                if (token) {
                    const decodedToken: any = jwtDecode(token);
                    if(decodedToken.auth && decodedToken.auth.length > 0){
                        this.permissions = decodedToken.auth.split(',')
                        .filter((permission: string) => permission.startsWith('ROLE_'));
                    }
                }
                resolve(this.permissions);
            }, 1000);
        });
    }

    public getPermissions(): string[] {
        return this.permissions;
    }

    public setPermissions(permissions: string[]): void {
        this.permissions = permissions;
    }

}
